/**
 * BugNoteAnnotationEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { BugNoteEntity } from "../BugNoteEntity";
import { BugNoteAnnotationEntity } from "../BugNoteAnnotationEntity";
declare global {
    interface EntityTypeMap {
        BugNoteAnnotation: BugNoteAnnotationEntity;
    }
}
export abstract class BugNoteAnnotationGeneratedEntity extends BaseEntity {
    public abstract templateId: string | null;
    public abstract creationDate: Date;
    public abstract hasMetadata: boolean;
    public abstract drawingHint: number;
    public abstract temp: boolean;
    public abstract bugNoteAnnotationId: string;
    public abstract bugNote: BugNoteEntity;
    public abstract parentAnnotatedEntity: BugNoteEntity;
}
